module.exports = __webpack_public_path__ + "img/BPPMP12.2a6e6eba.png";